import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { NzFormatEmitEvent, NzTreeNode } from 'ng-zorro-antd/tree';
import { IMTreeNodeOptions } from './typing';

@Component({
  selector: 'm-tree-directory',
  exportAs: 'mTreeDirectory',
  template: `
    <div class="m-tree-directory">
      <m-search-input *ngIf="mShowSearch" placeholder="检索目录" [(query)]="query"></m-search-input>
      <div class="m-tree-directory-container">
        <ng-container *ngIf="mTreeData?.length; else emptyResult">
          <nz-tree
            #nzTree
            [nzData]="mTreeData | filterTreeNodes: query"
            (nzClick)="onItemClick($event)"
            [nzTreeTemplate]="nzTreeTemplate"
          ></nz-tree>
          <ng-template #nzTreeTemplate let-node let-origin="origin">
            <span class="m-tree-directory-title">{{ node.title }}</span>
            <div class="m-tree-directory-num-block">
              <div *ngIf="origin.errorNum" class="m-tree-directory-num">
                <i nz-icon>
                  <svg
                    width="17px"
                    height="14px"
                    viewBox="0 0 17 14"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g id="交互页面" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="02章节模式-（章节模式）" transform="translate(-231.000000, -222.000000)">
                        <g id="编组-28" transform="translate(56.000000, 40.000000)">
                          <g id="编组-11" transform="translate(32.000000, 39.000000)">
                            <g id="编组-10" transform="translate(0.000000, 33.000000)">
                              <g id="-mockplus-" transform="translate(0.000000, 102.000000)">
                                <g id="-mockplus-" transform="translate(142.312500, 5.000000)">
                                  <g id="错误项/精简版" transform="translate(1.000000, 1.000000)">
                                    <g id="编组-10" transform="translate(0.772321, 0.000000)">
                                      <g id="check" transform="translate(0.468750, 2.000000)">
                                        <rect
                                          id="矩形"
                                          fill="#000000"
                                          fill-rule="nonzero"
                                          opacity="0"
                                          x="0"
                                          y="0"
                                          width="14"
                                          height="14"
                                        ></rect>
                                        <path
                                          d="M7,1.3125 C10.1411195,1.3125 12.6875,3.85888049 12.6875,7 C12.6875,10.1411195 10.1411195,12.6875 7,12.6875 C3.85888049,12.6875 1.3125,10.1411195 1.3125,7 C1.3125,3.85888049 3.85888049,1.3125 7,1.3125 Z M8.72780088,4.5625 L6.93241257,6.35797507 L5.13702426,4.5625 L4.5625,5.13702426 L6.35797507,6.93241257 L4.5625,8.72780088 L5.13702426,9.30232514 L6.93241257,7.50685007 L8.72780088,9.30232514 L9.30232514,8.72780088 L7.50685007,6.93241257 L9.30232514,5.13702426 L8.72780088,4.5625 Z"
                                          id="形状结合"
                                          fill="#EE5144"
                                        ></path>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </i>
                <p>{{ origin.errorNum }}</p>
              </div>
              <div *ngIf="origin.warningNum" class="m-tree-directory-num">
                <i nz-icon>
                  <svg
                    width="15px"
                    height="14px"
                    viewBox="0 0 15 14"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <defs>
                      <filter id="filter-1">
                        <feColorMatrix
                          in="SourceGraphic"
                          type="matrix"
                          values="0 0 0 0 0.919865 0 0 0 0 0.583981 0 0 0 0 0.000000 0 0 0 1.000000 0"
                        ></feColorMatrix>
                      </filter>
                    </defs>
                    <g id="交互页面" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="02章节模式-（章节模式）" transform="translate(-263.000000, -223.000000)">
                        <g id="编组-28" transform="translate(56.000000, 40.000000)">
                          <g id="编组-11" transform="translate(32.000000, 39.000000)">
                            <g id="编组-10" transform="translate(0.000000, 33.000000)">
                              <g id="-mockplus-" transform="translate(0.000000, 102.000000)">
                                <g id="-mockplus-" transform="translate(142.312500, 5.000000)">
                                  <g id="错误项/精简版" transform="translate(1.000000, 1.000000)">
                                    <g id="编组-10" transform="translate(0.772321, 0.000000)">
                                      <g id="编组-11" transform="translate(30.495536, 0.000000)">
                                        <g
                                          id="Icon/Fill/suggest/warning2"
                                          transform="translate(0.468750, 3.000000)"
                                          filter="url(#filter-1)"
                                        >
                                          <g>
                                            <rect
                                              id="矩形"
                                              fill="#000000"
                                              fill-rule="nonzero"
                                              opacity="0"
                                              x="0"
                                              y="0"
                                              width="14"
                                              height="14"
                                            ></rect>
                                            <path
                                              d="M8.06421796,2.52507315 L12.8771353,10.3966737 C13.463029,11.39888 12.9691605,12.25 11.8280481,12.25 L2.20221352,12.25 C1.02991488,12.25 0.536046371,11.4296009 1.12245132,10.3966737 L5.93536863,2.52507315 C6.52126232,1.49164228 7.47781301,1.49164228 8.06421796,2.52507315 Z M7.4375,9.275 L6.5625,9.275 L6.5625,10.15 L7.4375,10.15 L7.4375,9.275 Z M7.4375,4.375 L6.5625,4.375 L6.5625,8.05 L7.4375,8.05 L7.4375,4.375 Z"
                                              id="形状结合"
                                              fill="#FF9D1F"
                                            ></path>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </i>
                <p>{{ origin.warningNum }}</p>
              </div>
            </div>
          </ng-template>
        </ng-container>
        <ng-template #emptyResult>
          <nz-empty></nz-empty>
        </ng-template>
      </div>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MTreeDirectoryComponent {
  @Input() mTreeData: IMTreeNodeOptions[] = [];
  @Input() mShowSearch: boolean = true;
  @Output() readonly mNodeClick = new EventEmitter<NzTreeNode | null>();

  query = '';

  onItemClick(event: NzFormatEmitEvent): void {
    this.mNodeClick.emit(event.node);
  }
}
